export default "__VITE_ASSET__98817e74__"